// NPM imports
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";
import { NumberInput } from "../../../revvComponents";

// Actions Imports
import { numberForamting } from "../../../utils/globalUtils";
import { DealTableActions } from "../../../actions";

// Internal Imports
import { COMMON, GRID } from "../../../constants";

// Destructuring
const { CURRENCY_SYMBOL } = COMMON;
const { DEALTABLE_COLUMNS } = GRID;
const { onGroupDiscountUpdate } = DealTableActions;

class GroupTitleRenderer extends PureComponent {
  // On discount input value is changed
  _onDiscountChange = (key, value) => {
    const {
      metaData: { fieldMapIndex },
      dealTableId,
      discount,
      rowData,
    } = this.props;
    const discountClone = cloneDeep(discount);
    const netPriceFld = fieldMapIndex[DEALTABLE_COLUMNS.NET_PRICE];

    this.props.onGroupDiscountUpdate(
      rowData,
      discountClone,
      netPriceFld,
      dealTableId,
      key,
      value,
    );
  };

  render() {
    const currencySymbol = CURRENCY_SYMBOL[this.props.currency]; // Based on the pricebook show the respective currency symbol
    const { field, key } = this.props.node;
    const { groups } = this.props.discount;
    const groupData =
      groups &&
      groups.length > 0 &&
      groups.find(group => group.group_by_value === key);
    const rowCount = this.props.agGridReact.gridOptions.rowData.filter(
      row => row[field] === key,
    ).length;

    // Load the Component after onInit function has set the default values
    if (groupData) {
      const {
        group_total: total,
        discount_percent: discount,
        discountAmount,
        discountedGroupTotal,
      } = groupData;
      return (
        <div className="grouptitlerenderer-wrapper">
          <div className="grouptitlerenderer--group-title">
            {this.props.value} ({rowCount})
          </div>
          <div className="grouptitlerenderer-grouptotal-section">
            <div className="grouptitlerenderer-split-wrapper">
              <div className="grouptitlerenderer-grouptotal-split">
                <div className="grouptitlerenderer-title">
                  <span>Group Discount (%)</span>
                  <span> Group Discount ({currencySymbol})</span>
                </div>
                <div className="grouptitlerenderer-values">
                  <span className="grouptitlerenderer-discount-wrapper">
                    <NumberInput
                      className="grouptitlerenderer-discount-inp"
                      disabled={this.props.isLocked}
                      isFloat
                      limitTo={100}
                      onChange={value => this._onDiscountChange(key, value)}
                      placeholder="Discount"
                      value={discount}
                      data-test="grouptitlerenderer-number-input"
                    />
                  </span>
                  <span>{numberForamting(discountAmount, "")}</span>
                </div>
              </div>
              <div className="grouptitlerenderer-grouptotal-split">
                <div className="grouptitlerenderer-title">
                  <span>Group Total:</span>
                  <span>Discounted Group Total:</span>
                </div>
                <div className="grouptitlerenderer-values">
                  <span>{numberForamting(total, currencySymbol)}</span>
                  <span>
                    {numberForamting(discountedGroupTotal, currencySymbol)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="grouptitlerenderer-wrapper">
        <div className="grouptitlerenderer--group-title">
          {this.props.value}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // ::QUOTATION STORE
  const { dealTableId } = state.QuotationStore;

  // ::DEALTABLE STORE
  const {
    discount: { [dealTableId]: discount = {} } = {},
    metaData,
    priceBook: { [dealTableId]: priceBook = {} } = {},
    rowData: { [dealTableId]: rowData = [] } = {},
  } = state.DealTableStore;

  // ::DOCUMENT STORE
  const {
    document: { isLocked },
  } = state.DocumentStore;

  // ::ASSIGN REDUX KEYS TO RESPECTIVE DECLARED PROP VALUES
  const currency = (priceBook && priceBook.currency) || "USD";

  return { currency, dealTableId, discount, isLocked, metaData, rowData };
};

const mapDispatchToProps = {
  onGroupDiscountUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupTitleRenderer);
